import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list (params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        },
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };

    return axios.get(`${url}/workplaces`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function get (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/workplaces/${id}?include=port,activities,activityLabourers.activity,activityLabourers.labourer`, options)
        .then(response => {
            let workplace = jsona.deserialize(response.data);
            delete workplace.links;
            return workplace;
        });
}


function show (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/workplaces/${id}`, options)
        .then(response => {
            let workplace = jsona.deserialize(response.data);
            delete workplace.links;
            return workplace;
        });
}

function add (workplaces) {
    const payload = jsona.serialize({
        stuff: workplaces,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/workplaces`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function update (workplaces) {
    const payload = jsona.serialize({
        stuff: workplaces,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/workplaces/${workplaces.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function destroy (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/workplaces/${id}`, options);
}

function updateStatus (workplace) {
    const payload = jsona.serialize({
        stuff: workplace,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/workplace/status/${workplace.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function getStatusStatistics (params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        },
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };

    return axios.get(`${url}/workplaces/status/stats`, options)
        .then(response => {
            console.log(response.data.data);
            return response.data.data ? response.data.data : [];
        });
}

export default {
    list,
    get,
    show,
    add,
    updateStatus,
    update,
    destroy,
    getStatusStatistics
};

